import React from 'react';
import BannerPromozionaleImg from '../assets/images/banner-promozionale.png';
import IosDownloadImg from '../assets/images/ios-download.png';
import AndroidDownloadImg from '../assets/images/android-download.png';
import styles from './PromotionalBanner.module.css';
import { useIntl } from 'react-intl';

export const PromotionalBanner = ({ storeLinks }) => {
  const intl = useIntl();

  return (
    <div
      className={`container ${styles.bannerRowWrapper}`}
      style={{ maxWidth: 'inherit' }}
    >
      <div
        className={`row ${styles.bannerRowWrapper}`}
      >
        <div
          className={`col-12 col-md-6 ${styles.bannerLeftColumn}`}
          style={{
            backgroundImage: `url(${BannerPromozionaleImg})`,
          }}
        ></div>
        <div className="col-12 col-md-6 p-4 p-md-5 d-flex flex-column justify-content-center">
          <div className="row mb-3">
            <div
              className="col-12 col-md-9 col-lg-8 text-white"
              style={{
                fontSize: '1.5rem',
                fontWeight: '500'
              }}
            >
              {intl.formatMessage({ id: 'homePage.bannerPromozionale.scaricaMobileApp' })}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <a
                className="d-inline-block"
                href={storeLinks.iOS}
                style={{
                  backgroundImage: `url(${IosDownloadImg})`,
                  width: '140px',
                  height: '42px',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                <span style={{ display: 'none' }}>iOS download</span>
              </a>
              <a
                className="d-inline-block"
                href={storeLinks.android}
                style={{
                  backgroundImage: `url(${AndroidDownloadImg})`,
                  width: '140px',
                  height: '42px',
                  backgroundRepeat: 'no-repeat',
                }}
              >
                <span style={{ display: 'none' }}>Android download</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PromotionalBanner.displayName = 'PromotionalBanner';
